import React from 'react';

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  className = '',
  ...props
}) => {
  // Convert image URL to Unsplash optimization parameters if it's an Unsplash image
  const optimizedSrc = src.includes('unsplash.com') 
    ? `${src}${src.includes('?') ? '&' : '?'}auto=format&fit=crop&q=80`
    : src;

  return (
    <img
      src={optimizedSrc}
      alt={alt}
      className={`object-cover ${className}`}
      loading="lazy"
      decoding="async"
      {...props}
    />
  );
};

export default OptimizedImage;